import { SVGProps } from 'react'

const BackingBufferIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group 3130">
      <g id="Group 2064">
        <rect
          id="Rectangle 3975"
          x="0.445801"
          y="11.5312"
          width="16.875"
          height="4.21875"
          rx="2.10938"
          fill="currentColor"
        />
        <g id="Vector">
          <mask id="path-2-inside-1_13294_8024" fill="white">
            <path d="M17.3208 12.9375C17.3208 14.4914 13.5415 15.75 8.8833 15.75C4.2251 15.75 0.445801 14.4914 0.445801 12.9375" />
          </mask>
          <path
            d="M16.9763 12.9375C16.9763 13.1751 16.8321 13.4563 16.4443 13.7619C16.0603 14.0644 15.4834 14.3518 14.74 14.5996C13.2566 15.0939 11.1857 15.4055 8.8833 15.4055V16.0945C11.2391 16.0945 13.387 15.7768 14.9578 15.2533C15.7414 14.9922 16.4005 14.6736 16.8707 14.3031C17.3371 13.9357 17.6653 13.4768 17.6653 12.9375H16.9763ZM8.8833 15.4055C6.58092 15.4055 4.51003 15.0939 3.02665 14.5996C2.28315 14.3518 1.70626 14.0644 1.32233 13.7619C0.934506 13.4563 0.790332 13.1751 0.790332 12.9375H0.10127C0.10127 13.4768 0.429508 13.9357 0.895874 14.3031C1.36612 14.6736 2.0252 14.9922 2.8088 15.2533C4.37962 15.7768 6.52748 16.0945 8.8833 16.0945V15.4055Z"
            fill="currentColor"
            mask="url(#path-2-inside-1_13294_8024)"
          />
        </g>
        <g id="Group 2729">
          <g id="Group 2730">
            <rect
              id="Rectangle 3976"
              x="0.445801"
              y="14.625"
              width="16.875"
              height="1.40625"
              fill="white"
            />
            <rect
              id="Rectangle 3977"
              x="0.445801"
              y="14.625"
              width="16.875"
              height="0.5625"
              fill="currentColor"
            />
          </g>
          <g id="Vector_2">
            <mask id="path-6-inside-2_13294_8024" fill="white">
              <path d="M17.3208 15.1875C17.3208 16.7414 13.5415 18 8.8833 18C4.2251 18 0.445801 16.7414 0.445801 15.1875" />
            </mask>
            <path
              d="M16.2183 15.1875C16.2183 15.0933 16.2766 15.179 15.9752 15.4165C15.6862 15.6442 15.1997 15.8975 14.5003 16.1305C13.1131 16.5928 11.1269 16.8975 8.8833 16.8975V19.1025C11.2979 19.1025 13.5304 18.7779 15.1974 18.2224C16.0252 17.9466 16.7746 17.5938 17.3398 17.1485C17.8926 16.713 18.4233 16.0586 18.4233 15.1875H16.2183ZM8.8833 16.8975C6.6397 16.8975 4.65348 16.5928 3.26628 16.1305C2.56691 15.8975 2.08042 15.6442 1.79142 15.4165C1.49 15.179 1.5483 15.0933 1.5483 15.1875H-0.656699C-0.656699 16.0586 -0.125991 16.713 0.426777 17.1485C0.991968 17.5938 1.74144 17.9466 2.56917 18.2224C4.23617 18.7779 6.4687 19.1025 8.8833 19.1025V16.8975Z"
              fill="currentColor"
              mask="url(#path-6-inside-2_13294_8024)"
            />
          </g>
          <g id="Vector_3">
            <mask id="path-8-inside-3_13294_8024" fill="white">
              <path d="M17.3208 14.625C17.3208 16.1789 13.5415 17.4375 8.8833 17.4375C4.2251 17.4375 0.445801 16.1789 0.445801 14.625" />
            </mask>
            <path
              d="M16.2183 14.625C16.2183 14.5308 16.2766 14.6165 15.9752 14.854C15.6862 15.0817 15.1997 15.335 14.5003 15.568C13.1131 16.0303 11.1269 16.335 8.8833 16.335V18.54C11.2979 18.54 13.5304 18.2154 15.1974 17.6599C16.0252 17.3841 16.7746 17.0313 17.3398 16.586C17.8926 16.1505 18.4233 15.4961 18.4233 14.625H16.2183ZM8.8833 16.335C6.6397 16.335 4.65348 16.0303 3.26628 15.568C2.56691 15.335 2.08042 15.0817 1.79142 14.854C1.49 14.6165 1.5483 14.5308 1.5483 14.625H-0.656699C-0.656699 15.4961 -0.125991 16.1505 0.426777 16.586C0.991968 17.0313 1.74144 17.3841 2.56917 17.6599C4.23617 18.2154 6.4687 18.54 8.8833 18.54V16.335Z"
              fill="url(#paint0_linear_13294_8024)"
              mask="url(#path-8-inside-3_13294_8024)"
            />
          </g>
          <g id="Vector_4">
            <mask id="path-10-inside-4_13294_8024" fill="white">
              <path d="M17.3208 14.063C17.3208 15.6169 13.5415 16.8755 8.8833 16.8755C4.2251 16.8755 0.445801 15.6169 0.445801 14.063" />
            </mask>
            <path
              d="M16.2183 14.063C16.2183 13.9688 16.2766 14.0545 15.9752 14.292C15.6862 14.5197 15.1997 14.7729 14.5003 15.006C13.1131 15.4683 11.1269 15.773 8.8833 15.773V17.978C11.2979 17.978 13.5304 17.6534 15.1974 17.0979C16.0252 16.8221 16.7746 16.4693 17.3398 16.024C17.8926 15.5885 18.4233 14.9341 18.4233 14.063H16.2183ZM8.8833 15.773C6.6397 15.773 4.65348 15.4683 3.26628 15.006C2.56691 14.7729 2.08042 14.5197 1.79142 14.292C1.49 14.0545 1.5483 13.9688 1.5483 14.063H-0.656699C-0.656699 14.9341 -0.125991 15.5885 0.426777 16.024C0.991968 16.4693 1.74144 16.8221 2.56917 17.0979C4.23617 17.6534 6.4687 17.978 8.8833 17.978V15.773Z"
              fill="currentColor"
              mask="url(#path-10-inside-4_13294_8024)"
            />
          </g>
          <g id="Vector_5">
            <mask id="path-12-inside-5_13294_8024" fill="white">
              <path d="M17.3208 13.5C17.3208 15.0539 13.5415 16.3125 8.8833 16.3125C4.2251 16.3125 0.445801 15.0539 0.445801 13.5" />
            </mask>
            <path
              d="M16.2183 13.5C16.2183 13.4058 16.2766 13.4915 15.9752 13.729C15.6862 13.9567 15.1997 14.21 14.5003 14.443C13.1131 14.9053 11.1269 15.21 8.8833 15.21V17.415C11.2979 17.415 13.5304 17.0904 15.1974 16.5349C16.0252 16.2591 16.7746 15.9063 17.3398 15.461C17.8926 15.0255 18.4233 14.3711 18.4233 13.5H16.2183ZM8.8833 15.21C6.6397 15.21 4.65348 14.9053 3.26628 14.443C2.56691 14.21 2.08042 13.9567 1.79142 13.729C1.49 13.4915 1.5483 13.4058 1.5483 13.5H-0.656699C-0.656699 14.3711 -0.125991 15.0255 0.426777 15.461C0.991968 15.9063 1.74144 16.2591 2.56917 16.5349C4.23617 17.0904 6.4687 17.415 8.8833 17.415V15.21Z"
              fill="url(#paint1_linear_13294_8024)"
              mask="url(#path-12-inside-5_13294_8024)"
            />
          </g>
          <g id="Vector_6">
            <mask id="path-14-inside-6_13294_8024" fill="white">
              <path d="M17.3208 12.9375C17.3208 14.4914 13.5415 15.75 8.8833 15.75C4.2251 15.75 0.445801 14.4914 0.445801 12.9375" />
            </mask>
            <path
              d="M16.2183 12.9375C16.2183 12.8433 16.2766 12.929 15.9752 13.1665C15.6862 13.3942 15.1997 13.6475 14.5003 13.8805C13.1131 14.3428 11.1269 14.6475 8.8833 14.6475V16.8525C11.2979 16.8525 13.5304 16.5279 15.1974 15.9724C16.0252 15.6966 16.7746 15.3438 17.3398 14.8985C17.8926 14.463 18.4233 13.8086 18.4233 12.9375H16.2183ZM8.8833 14.6475C6.6397 14.6475 4.65348 14.3428 3.26628 13.8805C2.56691 13.6475 2.08042 13.3942 1.79142 13.1665C1.49 12.929 1.5483 12.8433 1.5483 12.9375H-0.656699C-0.656699 13.8086 -0.125991 14.463 0.426777 14.8985C0.991968 15.3438 1.74144 15.6966 2.56917 15.9724C4.23617 16.5279 6.4687 16.8525 8.8833 16.8525V14.6475Z"
              fill="currentColor"
              mask="url(#path-14-inside-6_13294_8024)"
            />
          </g>
          <g id="Vector_7">
            <mask id="path-16-inside-7_13294_8024" fill="white">
              <path d="M17.3208 12.9375C17.3208 11.3836 13.5415 10.125 8.8833 10.125C4.2251 10.125 0.445801 11.3836 0.445801 12.9375" />
            </mask>
            <path
              d="M16.2183 12.9375C16.2183 13.0317 16.2766 12.946 15.9752 12.7085C15.6862 12.4808 15.1997 12.2275 14.5003 11.9945C13.1131 11.5322 11.1269 11.2275 8.8833 11.2275V9.0225C11.2979 9.0225 13.5304 9.34708 15.1974 9.90258C16.0252 10.1784 16.7746 10.5312 17.3398 10.9765C17.8926 11.412 18.4233 12.0664 18.4233 12.9375H16.2183ZM8.8833 11.2275C6.6397 11.2275 4.65348 11.5322 3.26628 11.9945C2.56691 12.2275 2.08042 12.4808 1.79142 12.7085C1.49 12.946 1.5483 13.0317 1.5483 12.9375H-0.656699C-0.656699 12.0664 -0.125991 11.412 0.426777 10.9765C0.991968 10.5312 1.74144 10.1784 2.56917 9.90258C4.23617 9.34708 6.4687 9.0225 8.8833 9.0225V11.2275Z"
              fill="currentColor"
              mask="url(#path-16-inside-7_13294_8024)"
            />
          </g>
          <g id="Vector_8">
            <mask id="path-18-inside-8_13294_8024" fill="white">
              <path d="M17.3208 14.0625C17.3208 12.5086 13.5415 11.25 8.8833 11.25C4.2251 11.25 0.445801 12.5086 0.445801 14.0625" />
            </mask>
            <path
              d="M16.2183 14.0625C16.2183 14.1567 16.2766 14.071 15.9752 13.8335C15.6862 13.6058 15.1997 13.3525 14.5003 13.1195C13.1131 12.6572 11.1269 12.3525 8.8833 12.3525V10.1475C11.2979 10.1475 13.5304 10.4721 15.1974 11.0276C16.0252 11.3034 16.7746 11.6562 17.3398 12.1015C17.8926 12.537 18.4233 13.1914 18.4233 14.0625H16.2183ZM8.8833 12.3525C6.6397 12.3525 4.65348 12.6572 3.26628 13.1195C2.56691 13.3525 2.08042 13.6058 1.79142 13.8335C1.49 14.071 1.5483 14.1567 1.5483 14.0625H-0.656699C-0.656699 13.1914 -0.125991 12.537 0.426777 12.1015C0.991968 11.6562 1.74144 11.3034 2.56917 11.0276C4.23617 10.4721 6.4687 10.1475 8.8833 10.1475V12.3525Z"
              fill="currentColor"
              mask="url(#path-18-inside-8_13294_8024)"
            />
          </g>
        </g>
      </g>
      <g id="Group 2066">
        <rect
          id="Rectangle 3975_2"
          x="0.445801"
          y="8.15674"
          width="16.875"
          height="4.21875"
          rx="2.10938"
          fill="currentColor"
        />
        <g id="Vector_9">
          <mask id="path-21-inside-9_13294_8024" fill="white">
            <path d="M17.3208 9.5625C17.3208 11.1164 13.5415 12.375 8.8833 12.375C4.2251 12.375 0.445801 11.1164 0.445801 9.5625" />
          </mask>
          <path
            d="M16.9763 9.5625C16.9763 9.80014 16.8321 10.0813 16.4443 10.3869C16.0603 10.6894 15.4834 10.9768 14.74 11.2246C13.2566 11.7189 11.1857 12.0305 8.8833 12.0305V12.7195C11.2391 12.7195 13.387 12.4018 14.9578 11.8783C15.7414 11.6172 16.4005 11.2986 16.8707 10.9281C17.3371 10.5607 17.6653 10.1018 17.6653 9.5625H16.9763ZM8.8833 12.0305C6.58092 12.0305 4.51003 11.7189 3.02665 11.2246C2.28315 10.9768 1.70626 10.6894 1.32233 10.3869C0.934506 10.0813 0.790332 9.80014 0.790332 9.5625H0.10127C0.10127 10.1018 0.429508 10.5607 0.895874 10.9281C1.36612 11.2986 2.0252 11.6172 2.8088 11.8783C4.37962 12.4018 6.52748 12.7195 8.8833 12.7195V12.0305Z"
            fill="currentColor"
            mask="url(#path-21-inside-9_13294_8024)"
          />
        </g>
        <g id="Group 2729_2">
          <g id="Group 2730_2">
            <g id="Vector_10">
              <mask id="path-23-inside-10_13294_8024" fill="white">
                <path d="M17.3208 12.6567C17.3208 14.2106 13.5415 15.4692 8.8833 15.4692C4.2251 15.4692 0.445801 14.2106 0.445801 12.6567" />
              </mask>
              <path
                d="M16.2183 12.6567C16.2183 12.5625 16.2766 12.6483 15.9752 12.8858C15.6862 13.1135 15.1997 13.3667 14.5003 13.5997C13.1131 14.062 11.1269 14.3667 8.8833 14.3667V16.5717C11.2979 16.5717 13.5304 16.2472 15.1974 15.6917C16.0252 15.4158 16.7746 15.0631 17.3398 14.6177C17.8926 14.1822 18.4233 13.5279 18.4233 12.6567H16.2183ZM8.8833 14.3667C6.6397 14.3667 4.65348 14.062 3.26628 13.5997C2.56691 13.3667 2.08042 13.1135 1.79142 12.8858C1.49 12.6483 1.5483 12.5625 1.5483 12.6567H-0.656699C-0.656699 13.5279 -0.125991 14.1822 0.426777 14.6177C0.991968 15.0631 1.74144 15.4158 2.56917 15.6917C4.23617 16.2472 6.4687 16.5717 8.8833 16.5717V14.3667Z"
                fill="white"
                mask="url(#path-23-inside-10_13294_8024)"
              />
            </g>
            <rect
              id="Rectangle 3976_2"
              x="0.445801"
              y="11.25"
              width="16.875"
              height="1.40625"
              fill="white"
            />
            <rect
              id="Rectangle 3977_2"
              x="0.445801"
              y="11.25"
              width="16.875"
              height="0.5625"
              fill="currentColor"
            />
          </g>
          <g id="Vector_11">
            <mask id="path-27-inside-11_13294_8024" fill="white">
              <path d="M17.3208 11.8125C17.3208 13.3664 13.5415 14.625 8.8833 14.625C4.2251 14.625 0.445801 13.3664 0.445801 11.8125" />
            </mask>
            <path
              d="M16.2183 11.8125C16.2183 11.7183 16.2766 11.804 15.9752 12.0415C15.6862 12.2692 15.1997 12.5225 14.5003 12.7555C13.1131 13.2178 11.1269 13.5225 8.8833 13.5225V15.7275C11.2979 15.7275 13.5304 15.4029 15.1974 14.8474C16.0252 14.5716 16.7746 14.2188 17.3398 13.7735C17.8926 13.338 18.4233 12.6836 18.4233 11.8125H16.2183ZM8.8833 13.5225C6.6397 13.5225 4.65348 13.2178 3.26628 12.7555C2.56691 12.5225 2.08042 12.2692 1.79142 12.0415C1.49 11.804 1.5483 11.7183 1.5483 11.8125H-0.656699C-0.656699 12.6836 -0.125991 13.338 0.426777 13.7735C0.991968 14.2188 1.74144 14.5716 2.56917 14.8474C4.23617 15.4029 6.4687 15.7275 8.8833 15.7275V13.5225Z"
              fill="currentColor"
              mask="url(#path-27-inside-11_13294_8024)"
            />
          </g>
          <g id="Vector_12">
            <mask id="path-29-inside-12_13294_8024" fill="white">
              <path d="M17.3208 11.25C17.3208 12.8039 13.5415 14.0625 8.8833 14.0625C4.2251 14.0625 0.445801 12.8039 0.445801 11.25" />
            </mask>
            <path
              d="M16.2183 11.25C16.2183 11.1558 16.2766 11.2415 15.9752 11.479C15.6862 11.7067 15.1997 11.96 14.5003 12.193C13.1131 12.6553 11.1269 12.96 8.8833 12.96V15.165C11.2979 15.165 13.5304 14.8404 15.1974 14.2849C16.0252 14.0091 16.7746 13.6563 17.3398 13.211C17.8926 12.7755 18.4233 12.1211 18.4233 11.25H16.2183ZM8.8833 12.96C6.6397 12.96 4.65348 12.6553 3.26628 12.193C2.56691 11.96 2.08042 11.7067 1.79142 11.479C1.49 11.2415 1.5483 11.1558 1.5483 11.25H-0.656699C-0.656699 12.1211 -0.125991 12.7755 0.426777 13.211C0.991968 13.6563 1.74144 14.0091 2.56917 14.2849C4.23617 14.8404 6.4687 15.165 8.8833 15.165V12.96Z"
              fill="url(#paint2_linear_13294_8024)"
              mask="url(#path-29-inside-12_13294_8024)"
            />
          </g>
          <g id="Vector_13">
            <mask id="path-31-inside-13_13294_8024" fill="white">
              <path d="M17.3208 10.6875C17.3208 12.2414 13.5415 13.5 8.8833 13.5C4.2251 13.5 0.445801 12.2414 0.445801 10.6875" />
            </mask>
            <path
              d="M16.2183 10.6875C16.2183 10.5933 16.2766 10.679 15.9752 10.9165C15.6862 11.1442 15.1997 11.3975 14.5003 11.6305C13.1131 12.0928 11.1269 12.3975 8.8833 12.3975V14.6025C11.2979 14.6025 13.5304 14.2779 15.1974 13.7224C16.0252 13.4466 16.7746 13.0938 17.3398 12.6485C17.8926 12.213 18.4233 11.5586 18.4233 10.6875H16.2183ZM8.8833 12.3975C6.6397 12.3975 4.65348 12.0928 3.26628 11.6305C2.56691 11.3975 2.08042 11.1442 1.79142 10.9165C1.49 10.679 1.5483 10.5933 1.5483 10.6875H-0.656699C-0.656699 11.5586 -0.125991 12.213 0.426777 12.6485C0.991968 13.0938 1.74144 13.4466 2.56917 13.7224C4.23617 14.2779 6.4687 14.6025 8.8833 14.6025V12.3975Z"
              fill="currentColor"
              mask="url(#path-31-inside-13_13294_8024)"
            />
          </g>
          <g id="Vector_14">
            <mask id="path-33-inside-14_13294_8024" fill="white">
              <path d="M17.3208 10.125C17.3208 11.6789 13.5415 12.9375 8.8833 12.9375C4.2251 12.9375 0.445801 11.6789 0.445801 10.125" />
            </mask>
            <path
              d="M16.2183 10.125C16.2183 10.0308 16.2766 10.1165 15.9752 10.354C15.6862 10.5817 15.1997 10.835 14.5003 11.068C13.1131 11.5303 11.1269 11.835 8.8833 11.835V14.04C11.2979 14.04 13.5304 13.7154 15.1974 13.1599C16.0252 12.8841 16.7746 12.5313 17.3398 12.086C17.8926 11.6505 18.4233 10.9961 18.4233 10.125H16.2183ZM8.8833 11.835C6.6397 11.835 4.65348 11.5303 3.26628 11.068C2.56691 10.835 2.08042 10.5817 1.79142 10.354C1.49 10.1165 1.5483 10.0308 1.5483 10.125H-0.656699C-0.656699 10.9961 -0.125991 11.6505 0.426777 12.086C0.991968 12.5313 1.74144 12.8841 2.56917 13.1599C4.23617 13.7154 6.4687 14.04 8.8833 14.04V11.835Z"
              fill="url(#paint3_linear_13294_8024)"
              mask="url(#path-33-inside-14_13294_8024)"
            />
          </g>
          <g id="Vector_15">
            <mask id="path-35-inside-15_13294_8024" fill="white">
              <path d="M17.3208 9.5625C17.3208 11.1164 13.5415 12.375 8.8833 12.375C4.2251 12.375 0.445801 11.1164 0.445801 9.5625" />
            </mask>
            <path
              d="M16.2183 9.5625C16.2183 9.46831 16.2766 9.55402 15.9752 9.79152C15.6862 10.0192 15.1997 10.2725 14.5003 10.5055C13.1131 10.9678 11.1269 11.2725 8.8833 11.2725V13.4775C11.2979 13.4775 13.5304 13.1529 15.1974 12.5974C16.0252 12.3216 16.7746 11.9688 17.3398 11.5235C17.8926 11.088 18.4233 10.4336 18.4233 9.5625H16.2183ZM8.8833 11.2725C6.6397 11.2725 4.65348 10.9678 3.26628 10.5055C2.56691 10.2725 2.08042 10.0192 1.79142 9.79152C1.49 9.55402 1.5483 9.46831 1.5483 9.5625H-0.656699C-0.656699 10.4336 -0.125991 11.088 0.426777 11.5235C0.991968 11.9688 1.74144 12.3216 2.56917 12.5974C4.23617 13.1529 6.4687 13.4775 8.8833 13.4775V11.2725Z"
              fill="currentColor"
              mask="url(#path-35-inside-15_13294_8024)"
            />
          </g>
          <g id="Vector_16">
            <mask id="path-37-inside-16_13294_8024" fill="white">
              <path d="M17.3208 9.5625C17.3208 8.00859 13.5415 6.75 8.8833 6.75C4.2251 6.75 0.445801 8.00859 0.445801 9.5625" />
            </mask>
            <path
              d="M16.2183 9.5625C16.2183 9.65669 16.2766 9.57098 15.9752 9.33348C15.6862 9.10578 15.1997 8.85254 14.5003 8.61949C13.1131 8.15722 11.1269 7.8525 8.8833 7.8525V5.6475C11.2979 5.6475 13.5304 5.97208 15.1974 6.52758C16.0252 6.80341 16.7746 7.15618 17.3398 7.6015C17.8926 8.03703 18.4233 8.69136 18.4233 9.5625H16.2183ZM8.8833 7.8525C6.6397 7.8525 4.65348 8.15722 3.26628 8.61949C2.56691 8.85254 2.08042 9.10578 1.79142 9.33348C1.49 9.57098 1.5483 9.65669 1.5483 9.5625H-0.656699C-0.656699 8.69136 -0.125991 8.03703 0.426777 7.6015C0.991968 7.15618 1.74144 6.80341 2.56917 6.52758C4.23617 5.97208 6.4687 5.6475 8.8833 5.6475V7.8525Z"
              fill="currentColor"
              mask="url(#path-37-inside-16_13294_8024)"
            />
          </g>
          <g id="Vector_17">
            <mask id="path-39-inside-17_13294_8024" fill="white">
              <path d="M17.3208 10.6875C17.3208 9.13359 13.5415 7.875 8.8833 7.875C4.2251 7.875 0.445801 9.13359 0.445801 10.6875" />
            </mask>
            <path
              d="M16.2183 10.6875C16.2183 10.7817 16.2766 10.696 15.9752 10.4585C15.6862 10.2308 15.1997 9.97754 14.5003 9.74449C13.1131 9.28222 11.1269 8.9775 8.8833 8.9775V6.7725C11.2979 6.7725 13.5304 7.09708 15.1974 7.65258C16.0252 7.92841 16.7746 8.28118 17.3398 8.7265C17.8926 9.16203 18.4233 9.81636 18.4233 10.6875H16.2183ZM8.8833 8.9775C6.6397 8.9775 4.65348 9.28222 3.26628 9.74449C2.56691 9.97754 2.08042 10.2308 1.79142 10.4585C1.49 10.696 1.5483 10.7817 1.5483 10.6875H-0.656699C-0.656699 9.81636 -0.125991 9.16203 0.426777 8.7265C0.991968 8.28118 1.74144 7.92841 2.56917 7.65258C4.23617 7.09708 6.4687 6.7725 8.8833 6.7725V8.9775Z"
              fill="currentColor"
              mask="url(#path-39-inside-17_13294_8024)"
            />
          </g>
        </g>
      </g>
      <g id="Group 2065">
        <rect
          id="Rectangle 3975_3"
          x="0.445801"
          y="4.78125"
          width="16.875"
          height="4.21875"
          rx="2.10938"
          fill="currentColor"
        />
        <g id="Vector_18">
          <mask id="path-42-inside-18_13294_8024" fill="white">
            <path d="M17.3208 6.1875C17.3208 7.74141 13.5415 9 8.8833 9C4.2251 9 0.445801 7.74141 0.445801 6.1875" />
          </mask>
          <path
            d="M16.9763 6.1875C16.9763 6.42514 16.8321 6.70632 16.4443 7.01189C16.0603 7.31439 15.4834 7.60184 14.74 7.8496C13.2566 8.34392 11.1857 8.65547 8.8833 8.65547V9.34453C11.2391 9.34453 13.387 9.02678 14.9578 8.50333C15.7414 8.2422 16.4005 7.92364 16.8707 7.55313C17.3371 7.18567 17.6653 6.72681 17.6653 6.1875H16.9763ZM8.8833 8.65547C6.58092 8.65547 4.51003 8.34392 3.02665 7.8496C2.28315 7.60184 1.70626 7.31439 1.32233 7.01189C0.934506 6.70632 0.790332 6.42514 0.790332 6.1875H0.10127C0.10127 6.72681 0.429508 7.18567 0.895874 7.55313C1.36612 7.92364 2.0252 8.2422 2.8088 8.50333C4.37962 9.02678 6.52748 9.34453 8.8833 9.34453V8.65547Z"
            fill="currentColor"
            mask="url(#path-42-inside-18_13294_8024)"
          />
        </g>
        <g id="Group 2729_3">
          <g id="Group 2730_3">
            <g id="Vector_19">
              <mask id="path-44-inside-19_13294_8024" fill="white">
                <path d="M17.3208 9.28174C17.3208 10.8356 13.5415 12.0942 8.8833 12.0942C4.2251 12.0942 0.445801 10.8356 0.445801 9.28174" />
              </mask>
              <path
                d="M16.2183 9.28174C16.2183 9.18755 16.2766 9.27326 15.9752 9.51075C15.6862 9.73846 15.1997 9.99169 14.5003 10.2247C13.1131 10.687 11.1269 10.9917 8.8833 10.9917V13.1967C11.2979 13.1967 13.5304 12.8722 15.1974 12.3167C16.0252 12.0408 16.7746 11.6881 17.3398 11.2427C17.8926 10.8072 18.4233 10.1529 18.4233 9.28174H16.2183ZM8.8833 10.9917C6.6397 10.9917 4.65348 10.687 3.26628 10.2247C2.56691 9.99169 2.08042 9.73846 1.79142 9.51075C1.49 9.27326 1.5483 9.18755 1.5483 9.28174H-0.656699C-0.656699 10.1529 -0.125991 10.8072 0.426777 11.2427C0.991968 11.6881 1.74144 12.0408 2.56917 12.3167C4.23617 12.8722 6.4687 13.1967 8.8833 13.1967V10.9917Z"
                fill="white"
                mask="url(#path-44-inside-19_13294_8024)"
              />
            </g>
            <rect
              id="Rectangle 3976_3"
              x="0.445801"
              y="7.875"
              width="16.875"
              height="1.40625"
              fill="white"
            />
            <rect
              id="Rectangle 3977_3"
              x="0.445801"
              y="7.875"
              width="16.875"
              height="0.5625"
              fill="currentColor"
            />
          </g>
          <g id="Vector_20">
            <mask id="path-48-inside-20_13294_8024" fill="white">
              <path d="M17.3208 8.4375C17.3208 9.99141 13.5415 11.25 8.8833 11.25C4.2251 11.25 0.445801 9.99141 0.445801 8.4375" />
            </mask>
            <path
              d="M16.2183 8.4375C16.2183 8.34331 16.2766 8.42902 15.9752 8.66652C15.6862 8.89422 15.1997 9.14746 14.5003 9.38051C13.1131 9.84278 11.1269 10.1475 8.8833 10.1475V12.3525C11.2979 12.3525 13.5304 12.0279 15.1974 11.4724C16.0252 11.1966 16.7746 10.8438 17.3398 10.3985C17.8926 9.96297 18.4233 9.30864 18.4233 8.4375H16.2183ZM8.8833 10.1475C6.6397 10.1475 4.65348 9.84278 3.26628 9.38051C2.56691 9.14746 2.08042 8.89422 1.79142 8.66652C1.49 8.42902 1.5483 8.34331 1.5483 8.4375H-0.656699C-0.656699 9.30864 -0.125991 9.96297 0.426777 10.3985C0.991968 10.8438 1.74144 11.1966 2.56917 11.4724C4.23617 12.0279 6.4687 12.3525 8.8833 12.3525V10.1475Z"
              fill="currentColor"
              mask="url(#path-48-inside-20_13294_8024)"
            />
          </g>
          <g id="Vector_21">
            <mask id="path-50-inside-21_13294_8024" fill="white">
              <path d="M17.3208 7.875C17.3208 9.42891 13.5415 10.6875 8.8833 10.6875C4.2251 10.6875 0.445801 9.42891 0.445801 7.875" />
            </mask>
            <path
              d="M16.2183 7.875C16.2183 7.78081 16.2766 7.86652 15.9752 8.10402C15.6862 8.33172 15.1997 8.58496 14.5003 8.81801C13.1131 9.28028 11.1269 9.585 8.8833 9.585V11.79C11.2979 11.79 13.5304 11.4654 15.1974 10.9099C16.0252 10.6341 16.7746 10.2813 17.3398 9.836C17.8926 9.40047 18.4233 8.74614 18.4233 7.875H16.2183ZM8.8833 9.585C6.6397 9.585 4.65348 9.28028 3.26628 8.81801C2.56691 8.58496 2.08042 8.33172 1.79142 8.10402C1.49 7.86652 1.5483 7.78081 1.5483 7.875H-0.656699C-0.656699 8.74614 -0.125991 9.40047 0.426777 9.836C0.991968 10.2813 1.74144 10.6341 2.56917 10.9099C4.23617 11.4654 6.4687 11.79 8.8833 11.79V9.585Z"
              fill="url(#paint4_linear_13294_8024)"
              mask="url(#path-50-inside-21_13294_8024)"
            />
          </g>
          <g id="Vector_22">
            <mask id="path-52-inside-22_13294_8024" fill="white">
              <path d="M17.3208 7.3125C17.3208 8.86641 13.5415 10.125 8.8833 10.125C4.2251 10.125 0.445801 8.86641 0.445801 7.3125" />
            </mask>
            <path
              d="M16.2183 7.3125C16.2183 7.21831 16.2766 7.30402 15.9752 7.54152C15.6862 7.76922 15.1997 8.02246 14.5003 8.25551C13.1131 8.71778 11.1269 9.0225 8.8833 9.0225V11.2275C11.2979 11.2275 13.5304 10.9029 15.1974 10.3474C16.0252 10.0716 16.7746 9.71882 17.3398 9.2735C17.8926 8.83797 18.4233 8.18364 18.4233 7.3125H16.2183ZM8.8833 9.0225C6.6397 9.0225 4.65348 8.71778 3.26628 8.25551C2.56691 8.02246 2.08042 7.76922 1.79142 7.54152C1.49 7.30402 1.5483 7.21831 1.5483 7.3125H-0.656699C-0.656699 8.18364 -0.125991 8.83797 0.426777 9.2735C0.991968 9.71882 1.74144 10.0716 2.56917 10.3474C4.23617 10.9029 6.4687 11.2275 8.8833 11.2275V9.0225Z"
              fill="currentColor"
              mask="url(#path-52-inside-22_13294_8024)"
            />
          </g>
          <g id="Vector_23">
            <mask id="path-54-inside-23_13294_8024" fill="white">
              <path d="M17.3208 6.75C17.3208 8.30391 13.5415 9.5625 8.8833 9.5625C4.2251 9.5625 0.445801 8.30391 0.445801 6.75" />
            </mask>
            <path
              d="M16.2183 6.75C16.2183 6.65581 16.2766 6.74152 15.9752 6.97902C15.6862 7.20672 15.1997 7.45996 14.5003 7.69301C13.1131 8.15528 11.1269 8.46 8.8833 8.46V10.665C11.2979 10.665 13.5304 10.3404 15.1974 9.78492C16.0252 9.50909 16.7746 9.15632 17.3398 8.711C17.8926 8.27547 18.4233 7.62114 18.4233 6.75H16.2183ZM8.8833 8.46C6.6397 8.46 4.65348 8.15528 3.26628 7.69301C2.56691 7.45996 2.08042 7.20672 1.79142 6.97902C1.49 6.74152 1.5483 6.65581 1.5483 6.75H-0.656699C-0.656699 7.62114 -0.125991 8.27547 0.426777 8.711C0.991968 9.15632 1.74144 9.50909 2.56917 9.78492C4.23617 10.3404 6.4687 10.665 8.8833 10.665V8.46Z"
              fill="url(#paint5_linear_13294_8024)"
              mask="url(#path-54-inside-23_13294_8024)"
            />
          </g>
          <g id="Vector_24">
            <mask id="path-56-inside-24_13294_8024" fill="white">
              <path d="M17.3208 6.1875C17.3208 7.74141 13.5415 9 8.8833 9C4.2251 9 0.445801 7.74141 0.445801 6.1875" />
            </mask>
            <path
              d="M16.2183 6.1875C16.2183 6.09331 16.2766 6.17902 15.9752 6.41652C15.6862 6.64422 15.1997 6.89746 14.5003 7.13051C13.1131 7.59278 11.1269 7.8975 8.8833 7.8975V10.1025C11.2979 10.1025 13.5304 9.77792 15.1974 9.22242C16.0252 8.94659 16.7746 8.59382 17.3398 8.1485C17.8926 7.71297 18.4233 7.05864 18.4233 6.1875H16.2183ZM8.8833 7.8975C6.6397 7.8975 4.65348 7.59278 3.26628 7.13051C2.56691 6.89746 2.08042 6.64422 1.79142 6.41652C1.49 6.17902 1.5483 6.09331 1.5483 6.1875H-0.656699C-0.656699 7.05864 -0.125991 7.71297 0.426777 8.1485C0.991968 8.59382 1.74144 8.94659 2.56917 9.22242C4.23617 9.77792 6.4687 10.1025 8.8833 10.1025V7.8975Z"
              fill="currentColor"
              mask="url(#path-56-inside-24_13294_8024)"
            />
          </g>
          <g id="Vector_25">
            <mask id="path-58-inside-25_13294_8024" fill="white">
              <path d="M17.3208 6.1875C17.3208 4.63359 13.5415 3.375 8.8833 3.375C4.2251 3.375 0.445801 4.63359 0.445801 6.1875" />
            </mask>
            <path
              d="M16.2183 6.1875C16.2183 6.28169 16.2766 6.19598 15.9752 5.95848C15.6862 5.73078 15.1997 5.47754 14.5003 5.24449C13.1131 4.78222 11.1269 4.4775 8.8833 4.4775V2.2725C11.2979 2.2725 13.5304 2.59708 15.1974 3.15258C16.0252 3.42841 16.7746 3.78118 17.3398 4.2265C17.8926 4.66203 18.4233 5.31636 18.4233 6.1875H16.2183ZM8.8833 4.4775C6.6397 4.4775 4.65348 4.78222 3.26628 5.24449C2.56691 5.47754 2.08042 5.73078 1.79142 5.95848C1.49 6.19598 1.5483 6.28169 1.5483 6.1875H-0.656699C-0.656699 5.31636 -0.125991 4.66203 0.426777 4.2265C0.991968 3.78118 1.74144 3.42841 2.56917 3.15258C4.23617 2.59708 6.4687 2.2725 8.8833 2.2725V4.4775Z"
              fill="currentColor"
              mask="url(#path-58-inside-25_13294_8024)"
            />
          </g>
          <g id="Vector_26">
            <mask id="path-60-inside-26_13294_8024" fill="white">
              <path d="M17.3208 7.3125C17.3208 5.75859 13.5415 4.5 8.8833 4.5C4.2251 4.5 0.445801 5.75859 0.445801 7.3125" />
            </mask>
            <path
              d="M16.2183 7.3125C16.2183 7.40669 16.2766 7.32098 15.9752 7.08348C15.6862 6.85578 15.1997 6.60254 14.5003 6.36949C13.1131 5.90722 11.1269 5.6025 8.8833 5.6025V3.3975C11.2979 3.3975 13.5304 3.72208 15.1974 4.27758C16.0252 4.55341 16.7746 4.90618 17.3398 5.3515C17.8926 5.78703 18.4233 6.44136 18.4233 7.3125H16.2183ZM8.8833 5.6025C6.6397 5.6025 4.65348 5.90722 3.26628 6.36949C2.56691 6.60254 2.08042 6.85578 1.79142 7.08348C1.49 7.32098 1.5483 7.40669 1.5483 7.3125H-0.656699C-0.656699 6.44136 -0.125991 5.78703 0.426777 5.3515C0.991968 4.90618 1.74144 4.55341 2.56917 4.27758C4.23617 3.72208 6.4687 3.3975 8.8833 3.3975V5.6025Z"
              fill="currentColor"
              mask="url(#path-60-inside-26_13294_8024)"
            />
          </g>
        </g>
      </g>
      <g id="Group 2063">
        <rect
          id="Rectangle 3975_4"
          x="0.445801"
          y="1.40625"
          width="16.875"
          height="4.21875"
          rx="2.10938"
          fill="currentColor"
        />
        <g id="Vector_27">
          <mask id="path-63-inside-27_13294_8024" fill="white">
            <path d="M17.3208 2.81201C17.3208 4.36592 13.5415 5.62451 8.8833 5.62451C4.2251 5.62451 0.445801 4.36592 0.445801 2.81201" />
          </mask>
          <path
            d="M16.9763 2.81201C16.9763 3.04965 16.8321 3.33083 16.4443 3.6364C16.0603 3.93891 15.4834 4.22636 14.74 4.47412C13.2566 4.96843 11.1857 5.27998 8.8833 5.27998V5.96904C11.2391 5.96904 13.387 5.65129 14.9578 5.12784C15.7414 4.86671 16.4005 4.54816 16.8707 4.17764C17.3371 3.81019 17.6653 3.35132 17.6653 2.81201H16.9763ZM8.8833 5.27998C6.58092 5.27998 4.51003 4.96843 3.02665 4.47412C2.28315 4.22636 1.70626 3.93891 1.32233 3.6364C0.934506 3.33083 0.790332 3.04965 0.790332 2.81201H0.10127C0.10127 3.35132 0.429508 3.81019 0.895874 4.17764C1.36612 4.54816 2.0252 4.86671 2.8088 5.12784C4.37962 5.65129 6.52748 5.96904 8.8833 5.96904V5.27998Z"
            fill="currentColor"
            mask="url(#path-63-inside-27_13294_8024)"
          />
        </g>
        <g id="Group 2729_4">
          <g id="Group 2730_4">
            <g id="Vector_28">
              <mask id="path-65-inside-28_13294_8024" fill="white">
                <path d="M17.3208 5.90625C17.3208 7.46016 13.5415 8.71875 8.8833 8.71875C4.2251 8.71875 0.445801 7.46016 0.445801 5.90625" />
              </mask>
              <path
                d="M16.2183 5.90625C16.2183 5.81206 16.2766 5.89777 15.9752 6.13527C15.6862 6.36297 15.1997 6.61621 14.5003 6.84926C13.1131 7.31153 11.1269 7.61625 8.8833 7.61625V9.82125C11.2979 9.82125 13.5304 9.49667 15.1974 8.94117C16.0252 8.66534 16.7746 8.31257 17.3398 7.86725C17.8926 7.43172 18.4233 6.77739 18.4233 5.90625H16.2183ZM8.8833 7.61625C6.6397 7.61625 4.65348 7.31153 3.26628 6.84926C2.56691 6.61621 2.08042 6.36297 1.79142 6.13527C1.49 5.89777 1.5483 5.81206 1.5483 5.90625H-0.656699C-0.656699 6.77739 -0.125991 7.43172 0.426777 7.86725C0.991968 8.31257 1.74144 8.66534 2.56917 8.94117C4.23617 9.49667 6.4687 9.82125 8.8833 9.82125V7.61625Z"
                fill="white"
                mask="url(#path-65-inside-28_13294_8024)"
              />
            </g>
            <rect
              id="Rectangle 3976_4"
              x="0.445801"
              y="4.49951"
              width="16.875"
              height="1.40625"
              fill="white"
            />
            <rect
              id="Rectangle 3977_4"
              x="0.445801"
              y="4.49951"
              width="16.875"
              height="0.5625"
              fill="currentColor"
            />
          </g>
          <g id="Vector_29">
            <mask id="path-69-inside-29_13294_8024" fill="white">
              <path d="M17.3208 5.06201C17.3208 6.61592 13.5415 7.87451 8.8833 7.87451C4.2251 7.87451 0.445801 6.61592 0.445801 5.06201" />
            </mask>
            <path
              d="M16.2183 5.06201C16.2183 4.96782 16.2766 5.05354 15.9752 5.29103C15.6862 5.51873 15.1997 5.77197 14.5003 6.00502C13.1131 6.46729 11.1269 6.77201 8.8833 6.77201V8.97701C11.2979 8.97701 13.5304 8.65243 15.1974 8.09693C16.0252 7.8211 16.7746 7.46833 17.3398 7.02301C17.8926 6.58748 18.4233 5.93316 18.4233 5.06201H16.2183ZM8.8833 6.77201C6.6397 6.77201 4.65348 6.46729 3.26628 6.00502C2.56691 5.77197 2.08042 5.51873 1.79142 5.29103C1.49 5.05354 1.5483 4.96782 1.5483 5.06201H-0.656699C-0.656699 5.93316 -0.125991 6.58748 0.426777 7.02301C0.991968 7.46833 1.74144 7.8211 2.56917 8.09693C4.23617 8.65243 6.4687 8.97701 8.8833 8.97701V6.77201Z"
              fill="currentColor"
              mask="url(#path-69-inside-29_13294_8024)"
            />
          </g>
          <g id="Vector_30">
            <mask id="path-71-inside-30_13294_8024" fill="white">
              <path d="M17.3208 4.49951C17.3208 6.05342 13.5415 7.31201 8.8833 7.31201C4.2251 7.31201 0.445801 6.05342 0.445801 4.49951" />
            </mask>
            <path
              d="M16.2183 4.49951C16.2183 4.40532 16.2766 4.49104 15.9752 4.72853C15.6862 4.95623 15.1997 5.20947 14.5003 5.44252C13.1131 5.90479 11.1269 6.20951 8.8833 6.20951V8.41451C11.2979 8.41451 13.5304 8.08993 15.1974 7.53443C16.0252 7.2586 16.7746 6.90583 17.3398 6.46051C17.8926 6.02498 18.4233 5.37066 18.4233 4.49951H16.2183ZM8.8833 6.20951C6.6397 6.20951 4.65348 5.90479 3.26628 5.44252C2.56691 5.20947 2.08042 4.95623 1.79142 4.72853C1.49 4.49104 1.5483 4.40532 1.5483 4.49951H-0.656699C-0.656699 5.37066 -0.125991 6.02498 0.426777 6.46051C0.991968 6.90583 1.74144 7.2586 2.56917 7.53443C4.23617 8.08993 6.4687 8.41451 8.8833 8.41451V6.20951Z"
              fill="url(#paint6_linear_13294_8024)"
              mask="url(#path-71-inside-30_13294_8024)"
            />
          </g>
          <g id="Vector_31">
            <mask id="path-73-inside-31_13294_8024" fill="white">
              <path d="M17.3208 3.9375C17.3208 5.49141 13.5415 6.75 8.8833 6.75C4.2251 6.75 0.445801 5.49141 0.445801 3.9375" />
            </mask>
            <path
              d="M16.2183 3.9375C16.2183 3.84331 16.2766 3.92902 15.9752 4.16652C15.6862 4.39422 15.1997 4.64746 14.5003 4.88051C13.1131 5.34278 11.1269 5.6475 8.8833 5.6475V7.8525C11.2979 7.8525 13.5304 7.52792 15.1974 6.97242C16.0252 6.69659 16.7746 6.34382 17.3398 5.8985C17.8926 5.46297 18.4233 4.80864 18.4233 3.9375H16.2183ZM8.8833 5.6475C6.6397 5.6475 4.65348 5.34278 3.26628 4.88051C2.56691 4.64746 2.08042 4.39422 1.79142 4.16652C1.49 3.92902 1.5483 3.84331 1.5483 3.9375H-0.656699C-0.656699 4.80864 -0.125991 5.46297 0.426777 5.8985C0.991968 6.34382 1.74144 6.69659 2.56917 6.97242C4.23617 7.52792 6.4687 7.8525 8.8833 7.8525V5.6475Z"
              fill="currentColor"
              mask="url(#path-73-inside-31_13294_8024)"
            />
          </g>
          <g id="Vector_32">
            <mask id="path-75-inside-32_13294_8024" fill="white">
              <path d="M17.3208 3.375C17.3208 4.92891 13.5415 6.1875 8.8833 6.1875C4.2251 6.1875 0.445801 4.92891 0.445801 3.375" />
            </mask>
            <path
              d="M16.2183 3.375C16.2183 3.28081 16.2766 3.36652 15.9752 3.60402C15.6862 3.83172 15.1997 4.08496 14.5003 4.31801C13.1131 4.78028 11.1269 5.085 8.8833 5.085V7.29C11.2979 7.29 13.5304 6.96542 15.1974 6.40992C16.0252 6.13409 16.7746 5.78132 17.3398 5.336C17.8926 4.90047 18.4233 4.24614 18.4233 3.375H16.2183ZM8.8833 5.085C6.6397 5.085 4.65348 4.78028 3.26628 4.31801C2.56691 4.08496 2.08042 3.83172 1.79142 3.60402C1.49 3.36652 1.5483 3.28081 1.5483 3.375H-0.656699C-0.656699 4.24614 -0.125991 4.90047 0.426777 5.336C0.991968 5.78132 1.74144 6.13409 2.56917 6.40992C4.23617 6.96542 6.4687 7.29 8.8833 7.29V5.085Z"
              fill="url(#paint7_linear_13294_8024)"
              mask="url(#path-75-inside-32_13294_8024)"
            />
          </g>
          <g id="Vector_33">
            <mask id="path-77-inside-33_13294_8024" fill="white">
              <path d="M17.3208 2.81201C17.3208 4.36592 13.5415 5.62451 8.8833 5.62451C4.2251 5.62451 0.445801 4.36592 0.445801 2.81201" />
            </mask>
            <path
              d="M16.2183 2.81201C16.2183 2.71782 16.2766 2.80354 15.9752 3.04103C15.6862 3.26873 15.1997 3.52197 14.5003 3.75502C13.1131 4.21729 11.1269 4.52201 8.8833 4.52201V6.72701C11.2979 6.72701 13.5304 6.40243 15.1974 5.84693C16.0252 5.5711 16.7746 5.21833 17.3398 4.77301C17.8926 4.33748 18.4233 3.68316 18.4233 2.81201H16.2183ZM8.8833 4.52201C6.6397 4.52201 4.65348 4.21729 3.26628 3.75502C2.56691 3.52197 2.08042 3.26873 1.79142 3.04103C1.49 2.80354 1.5483 2.71782 1.5483 2.81201H-0.656699C-0.656699 3.68316 -0.125991 4.33748 0.426777 4.77301C0.991968 5.21833 1.74144 5.5711 2.56917 5.84693C4.23617 6.40243 6.4687 6.72701 8.8833 6.72701V4.52201Z"
              fill="currentColor"
              mask="url(#path-77-inside-33_13294_8024)"
            />
          </g>
          <g id="Vector_34">
            <mask id="path-79-inside-34_13294_8024" fill="white">
              <path d="M17.3208 2.81201C17.3208 1.25811 13.5415 -0.000488281 8.8833 -0.000488281C4.2251 -0.000488281 0.445801 1.25811 0.445801 2.81201" />
            </mask>
            <path
              d="M16.2183 2.81201C16.2183 2.9062 16.2766 2.82049 15.9752 2.583C15.6862 2.35529 15.1997 2.10206 14.5003 1.869C13.1131 1.40673 11.1269 1.10201 8.8833 1.10201V-1.10299C11.2979 -1.10299 13.5304 -0.778411 15.1974 -0.222907C16.0252 0.0529246 16.7746 0.405694 17.3398 0.851013C17.8926 1.28654 18.4233 1.94087 18.4233 2.81201H16.2183ZM8.8833 1.10201C6.6397 1.10201 4.65348 1.40673 3.26628 1.869C2.56691 2.10206 2.08042 2.35529 1.79142 2.583C1.49 2.82049 1.5483 2.9062 1.5483 2.81201H-0.656699C-0.656699 1.94087 -0.125991 1.28654 0.426777 0.851013C0.991968 0.405694 1.74144 0.0529246 2.56917 -0.222907C4.23617 -0.778411 6.4687 -1.10299 8.8833 -1.10299V1.10201Z"
              fill="currentColor"
              mask="url(#path-79-inside-34_13294_8024)"
            />
          </g>
          <g id="Vector_35">
            <mask id="path-81-inside-35_13294_8024" fill="white">
              <path d="M17.3208 3.88086C17.3208 2.32695 13.5415 1.06836 8.8833 1.06836C4.2251 1.06836 0.445801 2.32695 0.445801 3.88086" />
            </mask>
            <path
              d="M16.2183 3.88086C16.2183 3.97505 16.2766 3.88933 15.9752 3.65184C15.6862 3.42414 15.1997 3.1709 14.5003 2.93785C13.1131 2.47558 11.1269 2.17086 8.8833 2.17086V-0.0341406C11.2979 -0.0341406 13.5304 0.290436 15.1974 0.845941C16.0252 1.12177 16.7746 1.47454 17.3398 1.91986C17.8926 2.35539 18.4233 3.00971 18.4233 3.88086H16.2183ZM8.8833 2.17086C6.6397 2.17086 4.65348 2.47558 3.26628 2.93785C2.56691 3.1709 2.08042 3.42414 1.79142 3.65184C1.49 3.88933 1.5483 3.97505 1.5483 3.88086H-0.656699C-0.656699 3.00971 -0.125991 2.35539 0.426777 1.91986C0.991968 1.47454 1.74144 1.12177 2.56917 0.845941C4.23617 0.290436 6.4687 -0.0341406 8.8833 -0.0341406V2.17086Z"
              fill="currentColor"
              mask="url(#path-81-inside-35_13294_8024)"
            />
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_13294_8024"
        x1="8.8833"
        y1="14.625"
        x2="8.8833"
        y2="17.4375"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_13294_8024"
        x1="8.8833"
        y1="13.5"
        x2="8.8833"
        y2="16.3125"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_13294_8024"
        x1="8.8833"
        y1="11.25"
        x2="8.8833"
        y2="14.0625"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_13294_8024"
        x1="8.8833"
        y1="10.125"
        x2="8.8833"
        y2="12.9375"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_13294_8024"
        x1="8.8833"
        y1="7.875"
        x2="8.8833"
        y2="10.6875"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_13294_8024"
        x1="8.8833"
        y1="6.75"
        x2="8.8833"
        y2="9.5625"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_13294_8024"
        x1="8.8833"
        y1="4.49951"
        x2="8.8833"
        y2="7.31201"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_13294_8024"
        x1="8.8833"
        y1="3.375"
        x2="8.8833"
        y2="6.1875"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" />
      </linearGradient>
    </defs>
  </svg>
)

export default BackingBufferIcon
